import { constants } from '../constants';

const { CATEGORIES } = constants;

export const filterOptions = {
  category: CATEGORIES.map(({ name }) => name || 'Visi variantai'),
  type: ['Visi variantai', 'Parduodama', 'Nuomojama'],
  region: ['Visi variantai', 2, 3, 4, 5, 6, 7],
  rooms: [1, 2, 3, 4, '5+'],
  autos: [1, 2, 3, 4, '5+'],
  //SILDYMAS
  heating: [
    'Visi variantai',
    'Centrinis',
    'Centrinis kolektorinis',
    'Dujinis',
    'Elektra',
    'Aeroterminis',
    'Geoterminis',
    'Skystu kuru',
    'Kietu kuru',
    'Saulės baterijos',
    'Kita',
  ],
  //PASKIRTIS
  purposeLand: {
    0: 'Visi variantai',
    1: 'Namų valda',
    2: 'Daugiabučių statyba',
    3: 'Žemės ūkio',
    4: 'Sklypas soduose',
    5: 'Miškų ūkio',
    6: 'Pramonės',
    7: 'Sandėliavimo',
    8: 'Komercinė',
    9: 'Rekreacinė',
  },
  purposeCommercial: {
    0: 'Visi variantai',
    10: 'Administracinė',
    11: 'Prekybos',
    12: 'Viešbučių',
    13: 'Paslaugų',
    14: 'Sandėliavimo',
    15: 'Gamybos ir pramonės',
    16: 'Maitinimo',
  },
  // TIPAS
  materialGarage: {
    0: 'Visi variantai',
    1: 'Mūrinis',
    2: 'Geležinis',
    3: 'Požeminis',
    4: 'Daugiaaukštis',
  },
  materialCommercial: {
    0: 'Visi variantai',
    5: 'Požeminėje aikštelėje',
    6: 'Antžeminėje aikštelėje',
    7: 'Daugiaaukštėje aikštelėje',
  },
  //IRENGIMAS
  arrangement: [
    'Visi variantai',
    'Įrengtas',
    'Dalinė apdaila',
    'Neįrengtas',
    'Nebaigtas statyti',
    'Pamatai',
    'Kita',
  ],
};
